import React, { Component } from "react";
import dayjs from "dayjs";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import _ from "underscore";
import { ado } from "actions/ado";
import {
    setCustomExperiments,
    setExperiments,
    updateCustomExperiments,
} from "actions/experiments";
import Loader from "components/loader";
import Header from "components/header";
import Footer from "components/footer/footer";
import PopupsFactory from "components/popups/popupsFactory";
import TooltipsFactory from "components/tooltips/tooltipsFactory";
import GA from "lib/ga";
import Experiments from "lib/experiments";
import ErrorBoundary from "./errorBoundary";
import {
    isIframe,
    isMobile,
    isProduction,
    isQA,
} from "helpers/ApplicationHelper";
import User from "lib/user";

import PromotionBanner, {
    PromotionBtnLink,
    PromotionSessionStorageKey,
    PromotionBannerHeightMobileNumber,
    PromotionBannerHeightNumber,
} from "./banners/promotionBanner";

function getDateString(createdDate) {
    const created = dayjs(createdDate);
    const currentDate = dayjs();

    const datePlus7 = created.add(7, "day");
    const datePlus14 = created.add(14, "day");

    if (currentDate.isBefore(datePlus7)) {
        return datePlus7.format("MM/DD");
    } else {
        return datePlus14.format("MM/DD");
    }
}

class App extends Component {
    constructor(props) {
        super(props);
        this.isMobile = isMobile();

        this.state = {
            pendingExperiments: {
                status: false,
                data: null,
            },
            showPromotionBanner: false,
            setExperiments: false,
            bannerText: this.getBannerText(),
        };
        this.fsIdentified = !(isProduction() || isQA());
        this.updateExperiments = this.updateExperiments.bind(this);
        this.promotionClosed = this.promotionClosed.bind(this);
    }

    isShowPromotionBanner() {
        const isPromotion = true;
        const isShow =
            window.location.pathname.includes("/ll/") &&
            sessionStorage.getItem(PromotionSessionStorageKey) !== "true" &&
            isPromotion;
        return isShow;
    }

    componentDidMount() {
        Experiments.initAppExperimentsFromQuery(
            this.props.location,
            this.updateExperiments
        );
        this.props.ado();
        if (isIframe && document.domain != "localhost") {
            document.domain = "worthy.com";
        }

        // this.setState({ showPromotionBanner: this.isShowPromotionBanner() });
    }

    componentWillReceiveProps({ ADO, Session }) {
        if (Session && Session.isLoggedIn && !this.fsIdentified) {
            GA.userData(Session.userData);
            this.fsIdentified = true;
        }
        // Get User Experiments
        if (
            !this.state.setExperiments &&
            ADO &&
            _.isEmpty(ADO.experiments) &&
            Session?.isLoggedIn &&
            Session?.userData.isUser()
        ) {
            this.setState({ setExperiments: true });
            this.props.setExperiments(Session.userData.id);
        }

        if (
            this.state.pendingExperiments.status &&
            ADO &&
            Session.isLoggedIn &&
            Session.userData.isUser()
        ) {
            this.props.updateCustomExperiments(
                Session.userData.id,
                this.state.pendingExperiments.data
            );
            this.setState({
                pendingExperiments: { status: false, data: null },
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        let currentTitle = document.title;
        try {
            document.title =
                this.props.routes[this.props.routes.length - 1].title;
        } catch (e) {
            document.title = currentTitle;
        }

        // Notifying whenever a user is logged in for the first time.
        if (
            this.props.ADO &&
            this.props.ADO.user &&
            !(prevProps.ADO && prevProps.ADO.user)
        ) {
            User.performedLogin(this.props.ADO.user.id);
        }

        const bannerShow = this.isShowPromotionBanner();
        let isPromotion = prevState.showPromotionBanner;
        if (this.props.ADO && bannerShow) {
            if (this.props.ADO?.user?.created_at) {
                const createdDate = new Date(this.props.ADO.user.created_at);
                const promotionDate = new Date("2024-12-09");
                isPromotion = createdDate > promotionDate;
            }
        }
        if (isPromotion !== prevState.showPromotionBanner) {
            this.setState({
                showPromotionBanner: isPromotion,
                bannerText: this.getBannerText(),
            });
        }
    }

    getBannerText() {
        let createdDate = new Date();
        const reducedFeesText = 'Success Fees Reduced to Only 5% When You Ship by ';
        if (this.props.ADO?.user?.created_at) {
            createdDate = new Date(this.props.ADO.user.created_at);
        }
        return (
            reducedFeesText + getDateString(createdDate)
        );
    }

    updateExperiments(newExperiments) {
        this.setState({
            pendingExperiments: {
                status: true,
                data: newExperiments,
            },
        });
        this.props.setCustomExperiments(newExperiments);
    }

    promotionClosed() {
        this.setState({ showPromotionBanner: false });
    }

    render() {
        let section = this.props.routes[this.props.routes.length - 1].section;
        return (
            <ErrorBoundary>
                <div
                    className={`${this.props.Loading ? "loading" : ""} ${
                        section ? `section-${section}` : ""
                    }`}
                >
                    <Loader />
                    <PopupsFactory />
                    <TooltipsFactory />
                    {this.state.showPromotionBanner && (
                        <PromotionBanner
                            subtitle="Limited Time Offer:"
                            caption=""
                            title={this.state.bannerText}
                            btnText={""}
                            btnLink={PromotionBtnLink}
                            sessionStorageItemName={PromotionSessionStorageKey}
                            closeClb={this.promotionClosed.bind(this)}
                            clickClb={() => {
                                window.open(PromotionBtnLink, "_blank");
                            }}
                        />
                    )}
                    <Header
                        path={this.props.location.pathname}
                        showBanner={this.state.showPromotionBanner}
                    />

                    <div
                        id="content"
                        style={
                            this.state.showPromotionBanner
                                ? this.isMobile
                                    ? {
                                          paddingTop: `${
                                              60 +
                                              PromotionBannerHeightMobileNumber
                                          }px`,
                                      }
                                    : {
                                          paddingTop: `${
                                              60 + PromotionBannerHeightNumber
                                          }px`,
                                      }
                                : {}
                        }
                    >
                        {this.props.children}
                    </div>
                    <Footer path={this.props.location.pathname} />
                </div>
            </ErrorBoundary>
        );
    }
}

App.propTypes = {
    Loading: PropTypes.bool.isRequired,
    location: PropTypes.object,
};
App.defaultProps = {
    Loading: false,
};

const mapStateToProps = ({ ADO, Session, Experiments, Loaders }) => {
    return {
        ADO,
        Session,
        Experiments,
        Loading: Loaders._numberOfLoaders > 0,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        { ado, setExperiments, setCustomExperiments, updateCustomExperiments },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
